/**
 * Created by lycheng on 2019/9/5.
 */

import { player } from 'js/libs/jplayer/init-audio'
import * as servicesApi from 'js/api/services'
import { exLists } from 'js/config/read_solution_exlist'
import { Base64 } from 'js-base64'
import PCMPlayWorker from 'js/libs/pcm-play.worker.js'
import 'js/libs/gt'

let btnState = {
  unTTS: '立即合成',
  ttsing: '正在合成',
  endTTS: '立即播放',
  play: '停止播放',
  pause: '继续播放',
  endPlay: '重新播放',
  errorTTS: '合成失败'
}
const DEFAULT_TEXT = '科大讯飞成立于1999年，是中国先进的智能化语音技术提供商。我们提供的语音合成效果，达到了真正可商用的标准，您可以在这里输入任意文本进行语音合成体验。'

var isChrome = navigator.userAgent.toLowerCase().match(/chrome/)
var notSupportTip = isChrome ? '您的浏览器暂时不支持体验功能，请升级您的浏览器' : '您现在使用的浏览器暂时不支持体验功能，<br />推荐使用谷歌浏览器Chrome'

var audioCtx
var source
class Experience {
  constructor ({
    speed = 2,
    voice = 7,
    pitch = 7,
    text = '',
    engineType = 'intp65',
    tte = 'UTF8',
    voiceName = 'x_xiaofeng',
    playBtn = '.js-base-play',
    defaultText = ''
  } = {}) {
    this.speed = speed
    this.voice = voice
    this.pitch = pitch
    this.text = text
    this.defaultText = defaultText
    this.engineType = engineType
    this.tte = tte
    this.voiceName = voiceName
    this.playBtn = playBtn
    this.playState = ''
    this.audioDatas = []
    this.pcmPlayWork = new PCMPlayWorker()
    this.pcmPlayWork.onmessage = (e) => {
      this.onmessageWork(e)
    }
  }

  setConfig ({
    speed,
    voice,
    pitch,
    text,
    defaultText,
    engineType,
    voiceName,
    tte
  }) {
    speed !== undefined && (this.speed = speed)
    voice !== undefined && (this.voice = voice)
    pitch !== undefined && (this.pitch = pitch)
    text && (this.text = text)
    defaultText && (this.defaultText = defaultText)
    engineType && (this.engineType = engineType)
    tte && (this.tte = tte)
    voiceName && (this.voiceName = voiceName)
    this.resetAudio()
  }
  onmessageWork (e) {
    switch (e.data.command) {
      case 'newAudioData': {
        this.audioDatas.push(e.data.data)
        if (this.playState === 'ttsing' && this.audioDatas.length === 1) {
          this.playTimeout = setTimeout(() => {
            if (this.playState === 'unTTS') {
              this.resetAudio()
              return
            }
            this.audioPlay()
          }, 1000)
        }
        break
      }
    }
  }
  setBtnState (state) {
    let oldState = this.playState
    this.playState = state
    $(this.playBtn).removeClass(oldState).addClass(state).find('span').text(btnState[state])
  }

  getAudio (geetestResult) {
    this.setBtnState('ttsing')
    if (!this.captchaObj) {
      this.geetestInit()
      return
    }
    servicesApi.getTtsSign(geetestResult).then((result) => {
      if (this.playState === 'unTTS') {
        this.resetAudio()
        return
      }
      if (result.flag) {
        var url = result.data.url.replace('https://', 'wss://')
        this.connectWebsocket(url)
      } else {
        $.alerts.alert(result.desc || result.msg || '合成体验签名获取失败')
        this.resetAudio()
        return false
      }
    })
  }

  connectWebsocket (url) {
    if ('WebSocket' in window) {
      this.websocket = new WebSocket(url)
    } else if ('MozWebSocket' in window) {
      this.websocket = new MozWebSocket(url)
    } else {
      $.alerts.alert(notSupportTip)
      return
    }
    let self = this
    this.websocket.onopen = (e) => {
      if (this.playState === 'unTTS') {
        this.resetAudio()
        return
      }
      var params = {
        'common': {
          'app_id': '5d50d68b' // APPID
        },
        'business': {
          'ent': self.engineType,
          'aue': 'raw',
          'auf': 'audio/L16;rate=16000',
          'vcn': self.voiceName,
          'speed': self.speed,
          'volume': self.voice * 10,
          'pitch': self.pitch,
          'bgs': 1,
          'tte': self.tte
        },
        'data': {
          'status': 2,
          'text': self.encodeText(
            self.text || self.defaultText || DEFAULT_TEXT,
            self.tte === 'unicode' ? 'base64&utf16le' : ''
          )
        }
      }
      this.websocket.send(JSON.stringify(params))
    }
    this.websocket.onmessage = (e) => {
      if (this.playState === 'unTTS') {
        this.resetAudio()
        return
      }
      let jsonData = JSON.parse(e.data)
      // 识别结束
      if (jsonData.code !== 0) {
        $.alerts.alert(`${jsonData.code}:${jsonData.message}`)
        self.resetAudio()
        this.websocket.close()
        return
      }
      self.pcmPlayWork.postMessage({
        command: 'transData',
        data: jsonData.data.audio
      })

      if (jsonData.code === 0 && jsonData.data.status === 2) {
        this.websocket.close()
      }
    }
    this.websocket.onerror = (e) => {
      console.log(e)
    }
    this.websocket.onclose = (e) => {
      console.log(e)
    }
  }
  encodeText (text, encoding) {
    switch (encoding) {
      case 'utf16le' : {
        let buf = new ArrayBuffer(text.length * 4)
        let bufView = new Uint16Array(buf)
        for (let i = 0, strlen = text.length; i < strlen; i++) {
          bufView[i] = text.charCodeAt(i)
        }
        return buf
      }
      case 'buffer2Base64': {
        let binary = ''
        let bytes = new Uint8Array(text)
        let len = bytes.byteLength
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        return window.btoa(binary)
      }
      case 'base64&utf16le' : {
        return this.encodeText(this.encodeText(text, 'utf16le'), 'buffer2Base64')
      }
      default : {
        return Base64.encode(text)
      }
    }
  }
  resetAudio () {
    this.audioPause()
    this.setBtnState('unTTS')
    this.audioDatasIndex = 0
    this.audioDatas = []
    this.websocket && this.websocket.close()
    clearTimeout(this.playTimeout)
  }
  audioPlay () {
    try {
      if (!audioCtx) {
        audioCtx = new (window.AudioContext || window.webkitAudioContext)()
        audioCtx.resume()
      }
      if (!audioCtx) {
        $.alerts.alert(notSupportTip)
        return
      }
    } catch (e) {
      $.alerts.alert(notSupportTip)
      return
    }
    this.audioDatasIndex = 0
    if (this.audioDatas.length && this.playState !== 'unTTS') {
      this.playSource()
      this.setBtnState('play')
    } else {
      this.audioDatas = []
      if (!this.captchaObj) {
        this.geetestInit()
      } else {
        this.captchaObj.verify()
      }
    }
  }

  audioPause (state) {
    if (this.playState === 'play') {
      this.setBtnState(state || 'endPlay')
    }
    clearTimeout(this.playTimeout)
    try {
      source && source.stop()
    } catch (e) {
      console.log(e)
    }
  }
  playSource () {
    let bufferLength = 0
    let dataLength = this.audioDatas.length
    for (let i = this.audioDatasIndex; i < dataLength; i++) {
      bufferLength += this.audioDatas[i].length
    }
    let audioBuffer = audioCtx.createBuffer(1, bufferLength, 22050)
    let offset = 0
    let nowBuffering = audioBuffer.getChannelData(0)
    for (let i = this.audioDatasIndex; i < dataLength; i++) {
      let audioData = this.audioDatas[i]
      if (audioBuffer.copyToChannel) {
        audioBuffer.copyToChannel(audioData, 0, offset)
      } else {
        for (let j = 0; j < audioData.length; j++) {
          nowBuffering[offset + j] = audioData[j]
        }
      }
      offset += audioData.length
      this.audioDatasIndex++
    }

    source = audioCtx.createBufferSource()
    source.buffer = audioBuffer
    source.connect(audioCtx.destination)
    source.start()
    source.onended = (event) => {
      if (this.playState !== 'play') {
        return
      }
      if (this.audioDatasIndex < this.audioDatas.length) {
        this.playSource()
      } else {
        this.audioPause('endPlay')
      }
    }
  }

  geetestInit () {
    servicesApi.getValidate().then((result) => {
      initGeetest({
        gt: result.data.gt,
        challenge: result.data.challenge,
        offline: !result.data.success,
        new_captcha: result.data.new_captcha,
        product: 'bind', // 产品形式，包括：float，popup
        width: '300px'
        // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
      }, (captchaObj) => {
        this.captchaObj = captchaObj
        captchaObj.onReady(() => {
          captchaObj.verify()
        }).onSuccess(() => {
          let geetestResult = captchaObj.getValidate()
          if (!geetestResult) {
            return alert('请完成验证')
          }
          this.getAudio(geetestResult)
        })
      })
    })
  }
}

export default Experience



// WEBPACK FOOTER //
// ./src/js/libs/utils-tts-experience.js